<template>
  <div>

    <form action="/" method="get" class="searchJob" @submit.stop.prevent="submit()">
      <vue-bootstrap-typeahead
          :data="list"
          size="lg"
          inputClass="border-0 rounded-0"
          :minMatchingChars="parseInt(1)"
          :maxMatches="parseInt(4)"
          placeholder="Pesquisar Oportunidades"
          @hit="selected = $event"
          v-model="searchString">
          <template slot="append">
            <button class="btn btn-white border-0 rounded-0 d-flex" type="submit">
              <magnify-icon class="h4 mb-0 text-muted" />
            </button>
          </template>
      </vue-bootstrap-typeahead>
    </form>

  </div>
</template>

<script>
  import MagnifyIcon from "vue-material-design-icons/Magnify.vue"
  import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

  export default {
    name: 'SearchJob',

    data(){
      return {
        searchString: '',
        selected: ''
      }
    },

    computed: {
      list(){
        return this.$store.state.opportunities.uniqueTitles.map( opportinity => this.$helpers.toTitle(opportinity) )
      }
    },

    components: {
      MagnifyIcon,
      VueBootstrapTypeahead
    },

    methods: {
      submit(){
        this.$store.commit('opportunities/ADD_SEARCH_JOB_TERM', this.searchString);
        this.$EventBus.$emit('searchJob');

        this.$route.name == 'home' && this.$router.push("/vagas/");
      },

      cleanInput(){
        this.$store.commit('opportunities/CLEAR_SEARCH_JOB_TERM');
      },

      setInput(){
        const _searchInput = document.querySelector('.searchJob .form-control');
        if( _searchInput ) _searchInput.value = this.$store.state.opportunities.searchTerm;
      }
    },

    beforeDestroy() {
      this.$EventBus.$off('searchJob');
    },

    mounted() {
      this.setInput();
      this.$EventBus.$on('cleanInput', this.cleanInput)
    },

    watch: {
      selected: function (val) {
        this.submit();
      }
    }
  }
</script>

<style lang="scss">
  .searchJob{
    .form-control{
      &::placeholder{ font-size: 1.15rem; }
      &:-ms-input-placeholder{ font-size: 1.15rem; }
      &::-ms-input-placeholder{ font-size: 1.15rem; }
    }
  }
</style>